import {
  AdminPreviewDistributionGroupMembershipInput,
  MessageThreadType,
} from "gql/graphql";
import React, {
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { FORWARD_TO_STATE } from "modules/utils/Constants";
import type { IWebSocketPayloadIncomingCall } from "../websocket-provider/types";
import { IFileInTransit } from "../index-db-provider/index-db-models";
import { RuleGroupType } from "react-querybuilder";

export enum DRAWER_TYPE {
  COMPOSE_THREAD = "COMPOSE_THREAD",
  COMPOSE_CHAT = "COMPOSE_CHAT",
  COMPOSE_TASK = "COMPOSE_TASK",

  COMPOSE_HAPPYCO_THREAD = "COMPOSE_HAPPYCO_THREAD",

  MESSAGE_PROFILE = "MESSAGE_PROFILE",
  MESSAGE_THREAD_PROFILE = "MESSAGE_THREAD_PROFILE",
  MESSAGE_THREAD_FILES = "MESSAGE_THREAD_FILES",
  MESSAGE_THREAD_FILTER = "MESSAGE_THREAD_FILTER",
  RElATED_MESSAGE_THREADS = "RElATED_MESSAGE_THREADS",
  FORWARD_MESSAGE_THREAD = "FORWARD_MESSAGE_THREAD",
  GENERATE_TASK_FROM_MESSAGES = "GENERATE_TASK_FROM_MESSAGES",
  SUPPORT = "SUPPORT",
  DOWNLOADS_EXPORTS = "DOWNLOADS_EXPORTS",
  USER_PROFILE = "USER_PROFILE",
  DISTRIBUTION_GROUP_PROFILE = "DISTRIBUTION_GROUP_PROFILE",

  SEARCH_FILTERS = "SEARCH_FILTERS",

  HAPPYCO_CREATE_WORK_ORDER = "HAPPYCO_CREATE_WORK_ORDER",
  HAPPYCO_EXPORT_TO_EXISTING_WORK_ORDER = "HAPPYCO_EXPORT_TO_EXISTING_WORK_ORDER",

  ADMIN_USER = "ADMIN_USER",
  ADMIN_ADD_USER = "ADMIN_ADD_USER",
  ADMIN_DISTRIBUTION_GROUP = "ADMIN_DISTRIBUTION_GROUP",
  ADMIN_ADD_EDIT_DISTRIBUTION_GROUP = "ADMIN_ADD_EDIT_DISTRIBUTION_GROUP",
  ADMIN_TAG = "ADMIN_TAG",
  ADMIN_TAG_CATEGORY = "ADMIN_TAG_CATEGORY",
  ADMIN_USER_ATTRIBUTE_CATEGORY = "ADMIN_USER_ATTRIBUTE_CATEGORY",

  INTERNAL_ADMIN_USER = "INTERNAL_ADMIN_USER",
  INTERNAL_ADMIN_ADD_USER = "INTERNAL_ADMIN_ADD_USER",
  INTERNAL_ADMIN_DISTRIBUTION_GROUP = "INTERNAL_ADMIN_DISTRIBUTION_GROUP",
  INTERNAL_ADMIN_ADD_EDIT_DISTRIBUTION_GROUP = "INTERNAL_ADMIN_ADD_EDIT_DISTRIBUTION_GROUP",
  INTERNAL_ADMIN_TAG = "INTERNAL_ADMIN_TAG",
  INTERNAL_ADMIN_TAG_CATEGORY = "INTERNAL_ADMIN_TAG_CATEGORY",
  INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY = "INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY",

  VIDEO_CALL_ADD_PARTICIPANTS = "VIDEO_CALL_ADD_PARTICIPANTS",
  VIDEO_CALL_PARTICIPANTS = "VIDEO_CALL_PARTICIPANTS",
}

export enum MODAL_TYPE {
  HELP = "HELP",
  CONFIRM = "CONFIRM",
  MESSAGE_THREAD_FILE_GALLERY = "MESSAGE_THREAD_FILE_GALLERY",
  EDIT_SUBJECT = "EDIT_SUBJECT",
  CREATE_REMINDER = "CREATE_REMINDER",
  DELETE_MESSAGE = "DELETE_MESSAGE",
  DELETE_FILE = "DELETE_FILE",
  EDIT_USER_AVATAR = "EDIT_USER_AVATAR",
  EDIT_IMAGE = "EDIT_IMAGE",
  EDIT_USER_LOCALE = "EDIT_USER_LOCALE",
  EDIT_MESSAGE = "EDIT_MESSAGE",
  EMAIL_INFO = "EMAIL_INFO",
  MAKE_PRIVATE_GENERAL_INFO = "MAKE_PRIVATE_GENERAL_INFO",
  CONFIRM_UNLOCK_CONVERSATION = "CONFIRM_UNLOCK_CONVERSATION",
  CONFIRM_REMOVE_USERS_GROUPS = "CONFIRM_REMOVE_USERS_GROUPS",
  LOCKED_CONVERSATION = "LOCKED_CONVERSATION",
  UNLOCKED_CONVERSATION = "UNLOCKED_CONVERSATION",
  ADD_EXTERNAL_EMAIL_USERS = "ADD_EXTERNAL_EMAIL_USERS",
  PRINT_CONVERSATION = "PRINT_CONVERSATION",
  EXPORT_CONVERSATION = "EXPORT_CONVERSATION",
  DOWNLOAD_ALL_FILES = "DOWNLOAD_ALL_FILES",
  DELETE_ALL_JOBS = "DELETE_ALL_JOBS",
  PINNED_MESSAGE_THREADS_LIMIT = "PINNED_MESSAGE_THREADS_LIMIT",
  CALL_OPTIONS = "CALL_OPTIONS",
  INCOMING_CALL = "INCOMING_CALL",
  DISABLE_SMS = "DISABLE_SMS",
  ADD_PENDING_EMAIL_USERS = "ADD_PENDING_EMAIL_USERS",
  FILE_IN_TRANSIT = "FILE_IN_TRANSIT",
  OUT_OF_OFFICE = "OUT_OF_OFFICE",
  INVITE = "INVITE",
  READ_ONLY_INFO = "READ_ONLY_INFO",
  CONFIRM_READ_ONLY_THREAD = "CONFIRM_READ_ONLY_THREAD",
  CONFIRM_REMOVE_READ_ONLY_THREAD = "CONFIRM_REMOVE_READ_ONLY_THREAD",

  ADMIN_TAG_CATEGORY = "ADMIN_TAG_CATEGORY",
  ADMIN_DEACTIVATE_USER = "ADMIN_DEACTIVATE_USER",
  ADMIN_DEACTIVATE_MULTIPLE_USERS = "ADMIN_DEACTIVATE_MULTIPLE_USERS",
  ADMIN_REACTIVATE_USER = "ADMIN_REACTIVATE_USER",
  ADMIN_CONFIRM_ARCHIVE_DISTRIBUTION_GROUP = "ADMIN_CONFIRM_ARCHIVE_DISTRIBUTION_GROUP",
  ADMIN_CONFIRM_UNARCHIVE_DISTRIBUTION_GROUP = "ADMIN_CONFIRM_UNARCHIVE_DISTRIBUTION_GROUP",
  ADMIN_CONFIRM_ARCHIVE_TAG = "ADMIN_CONFIRM_ARCHIVE_TAG",
  ADMIN_CONFIRM_UNARCHIVE_TAG = "ADMIN_CONFIRM_UNARCHIVE_TAG",
  ADMIN_DISTRIBUTION_GROUP_QUERY = "ADMIN_DISTRIBUTION_GROUP_QUERY",
  ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS = "ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS",
  ADMIN_DISTRIBUTION_GROUP_ADDED = "ADMIN_DISTRIBUTION_GROUP_ADDED",
  ADMIN_ADD_USER_ATTRIBUTE_CATEGORY = "ADMIN_ADD_USER_ATTRIBUTE_CATEGORY",
  ADMIN_EDIT_USER_ATTRIBUTES = "ADMIN_EDIT_USER_ATTRIBUTES",
  ADMIN_CREATE_TAG = "ADMIN_CREATE_TAG",
  ADMIN_EDIT_TAG = "ADMIN_EDIT_TAG",
  ADMIN_CREATE_USER_ATTRIBUTE_TAG = "ADMIN_CREATE_USER_ATTRIBUTE_TAG",
  ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS = "ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS",

  INTERNAL_ADMIN_ADD_ORGANIZATION = "INTERNAL_ADMIN_ADD_ORGANIZATION",
  INTERNAL_ADMIN_CREATE_TAG = "INTERNAL_ADMIN_CREATE_TAG",
  INTERNAL_ADMIN_EDIT_TAG = "INTERNAL_ADMIN_EDIT_TAG",
  INTERNAL_ADMIN_TAG_CATEGORY = "INTERNAL_ADMIN_TAG_CATEGORY",
  INTERNAL_ADMIN_DEACTIVATE_USER = "INTERNAL_ADMIN_DEACTIVATE_USER",
  INTERNAL_ADMIN_DEACTIVATE_MULTIPLE_USERS = "INTERNAL_ADMIN_DEACTIVATE_MULTIPLE_USERS",
  INTERNAL_ADMIN_REACTIVATE_USER = "INTERNAL_ADMIN_REACTIVATE_USER",
  INTERNAL_ADMIN_CONFIRM_ARCHIVE_TAG = "INTERNAL_ADMIN_CONFIRM_ARCHIVE_TAG",
  INTERNAL_ADMIN_CONFIRM_UNARCHIVE_TAG = "INTERNAL_ADMIN_CONFIRM_UNARCHIVE_TAG",
  INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY = "INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY",
  INTERNAL_ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS = "INTERNAL_ADMIN_DISTRIBUTION_GROUP_PREVIEW_USERS",
  INTERNAL_ADMIN_EDIT_USER_ATTRIBUTES = "INTERNAL_ADMIN_EDIT_USER_ATTRIBUTES",
  INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE = "INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE",
  INTERNAL_ADMIN_ADD_USER_ATTRIBUTE_CATEGORY = "INTERNAL_ADMIN_ADD_USER_ATTRIBUTE_CATEGORY",
  INTERNAL_ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS = "INTERNAL_ADMIN_ADD_USERS_TO_DISTRIBUTION_GROUPS",
}

export interface IDrawerParams {
  type: DRAWER_TYPE;
  id?: string;
  id2?: string;
  ids?: string[];
  messageThreadType?: MessageThreadType;
  onCloseCallback?: () => void;
  forwardToState?: FORWARD_TO_STATE;
  /** For `VIDEO_CALL_ADD_PARTICIPANTS` */
  videoCallId?: string;
  /** For video call drawers */
  videoCallAccessUserIds?: string[];
  /** For `VIDEO_CALL_PARTICIPANTS` — user IDs currently connected in LiveKit. */
  videoCallActiveUserIds?: string[];
}

export interface IHelpModal {
  icon?: ReactNode;
  title?: string;
  message?: string | ReactNode;
}

export interface IModalParams {
  type: MODAL_TYPE;
  id?: string;
  id2?: string;
  ids?: string[];
  onCloseCallback?: () => void;
  onSaveCallback?: Function;
  call?: IWebSocketPayloadIncomingCall;
  fileInTransit?: IFileInTransit;
  query?: RuleGroupType;
  helpModal?: IHelpModal;
  isCloseAllModals?: boolean;

  adminPreviewDistributionGroupMembershipInput?: AdminPreviewDistributionGroupMembershipInput;
}

interface ICloseDrawersParams {
  types: DRAWER_TYPE[];
}

interface ICloseModalsParams {
  /** Modals in the stack matching the predicate are removed, wherever they are. */
  predicate: (modal: IModalParams) => boolean;
}

interface IOverlay {
  openDrawer: (params: IDrawerParams) => void;
  openModal: (params: IModalParams) => void;
  closeDrawer: (
    e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement> | undefined,
  ) => void;
  closeDrawers: (params?: ICloseDrawersParams) => void;
  closeModal: (
    e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement> | undefined,
  ) => void;
  closeModals: (params: ICloseModalsParams) => void;
  drawerState?: IDrawerParams;
  modalState?: IModalParams;
}

const OverlayContext = React.createContext<IOverlay>({
  openDrawer: () => null,
  openModal: () => null,
  closeDrawer: () => null,
  closeDrawers: () => null,
  closeModal: () => null,
  closeModals: () => null,
});

export interface IOverlayProps {
  children?: ReactNode;
}

export const OverlayProvider = ({ children }: IOverlayProps) => {
  const [drawerState, setDrawerState] = useState<IDrawerParams>();
  const [modalStack, setModalStack] = useState<IModalParams[]>([]);

  const modalState = modalStack.at(-1);

  const closeDrawer = useCallback(
    (
      e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement> | undefined,
    ) => {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      if (drawerState?.onCloseCallback) {
        drawerState?.onCloseCallback();
      }
      setDrawerState(undefined);
    },
    [drawerState],
  );

  const closeDrawers = useCallback(
    (params?: ICloseDrawersParams) => {
      if (
        params?.types &&
        drawerState &&
        !params.types.includes(drawerState?.type)
      ) {
        return;
      }
      if (drawerState?.onCloseCallback) {
        drawerState?.onCloseCallback();
      }
      setDrawerState(undefined);
    },
    [drawerState],
  );

  const openModal = useCallback((params: IModalParams) => {
    setModalStack((prev) => [...prev, params]);
  }, []);

  const closeModal = useCallback(
    (
      e?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement> | undefined,
    ) => {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      if (modalState?.onCloseCallback) {
        modalState?.onCloseCallback();
      }
      if (modalState?.isCloseAllModals) {
        setModalStack([]);
        return;
      }
      setModalStack((prev) => prev.slice(0, -1));
    },
    [modalState],
  );

  const closeModals = useCallback((params: ICloseModalsParams) => {
    setModalStack((prev) => prev.filter((modal) => !params.predicate(modal)));
  }, []);

  const openDrawer = useCallback(
    (params: IDrawerParams) => {
      closeModal();
      setDrawerState(params);
    },
    [closeModal],
  );

  const overlay = useMemo<IOverlay>(
    () => ({
      openDrawer,
      openModal,
      closeDrawer,
      closeDrawers,
      closeModal,
      closeModals,
      drawerState,
      modalState,
    }),
    [
      closeDrawer,
      closeDrawers,
      closeModal,
      closeModals,
      drawerState,
      modalState,
      openDrawer,
      openModal,
    ],
  );

  return (
    <OverlayContext.Provider value={overlay}>
      {children}
    </OverlayContext.Provider>
  );
};

export const useOverlay = () => useContext(OverlayContext);
